import { IVwRestricoesAlimentares } from '../../../types/views/IVwRestricoesAlimentares';
import { BaseMultiTenantService } from '../base/BaseMultiTenantService';

export class RestricoesAlimentaresViewService extends BaseMultiTenantService<IVwRestricoesAlimentares> {
  constructor() {
    super('vw_restricoes_alimentares', ['produto_descricao', 'observacoes'], 'fk_id_organizacao');
  }
}

export const restricoesAlimentaresViewService = new RestricoesAlimentaresViewService();
